// TODO поправить типизацию в файле
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpInterceptor,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, Subject, throwError, Subscriber } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isTokenRefreshing = false;

  private tokenRefreshedSource: Subject<void> = new Subject<void>();
  private tokenRefreshed$: Observable<void> =
    this.tokenRefreshedSource.asObservable();

  private readonly redirectIgnoreUrls: string[] = [''];

  constructor(private readonly oauthService: OAuthService) {}

  public intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(this.updateRequestHeader(request)).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          return this.refreshToken(request).pipe(
            switchMap(() => next.handle(this.updateRequestHeader(request))),
            catchError((error) => {
              this.oauthService.logOut();

              return throwError(error);
            }),
          );
        }

        if (error instanceof HttpErrorResponse && error.status === 403) {
          this.oauthService.logOut();
        }

        return throwError(error);
      }),
    );
  }

  private updateRequestHeader(request: HttpRequest<any>): HttpRequest<any> {
    const token = this.oauthService.getAccessToken();
    if (token) {
      const headers = request.headers.set(
        'Authorization',
        this.oauthService.authorizationHeader(),
      );
      request = request.clone({ headers });
    }

    return request;
  }

  private refreshToken(request: HttpRequest<any>): Observable<HttpEvent<any>> {
    if (this.isTokenRefreshing) {
      return this.getNewRefreshObservable();
    } else {
      this.isTokenRefreshing = true;

      return new Observable((observer) => {
        this.oauthService
          .refreshToken()
          .then(
            () => {
              this.tokenRefreshedSource.next();
              observer.next();
              observer.complete();
            },
            () => this.onRefreshError(request, observer),
          )
          .catch(() => this.onRefreshError(request, observer))
          .finally(() => (this.isTokenRefreshing = false));
      });
    }
  }

  private onRefreshError(
    request: HttpRequest<any>,
    observer: Subscriber<HttpEvent<any>>,
  ): void {
    observer.error('Cannot refresh token');
    if (!this.redirectIgnoreUrls.some((url) => request.url.includes(url))) {
      this.oauthService.loadDiscoveryDocumentAndLogin().then();
    }
  }

  private getNewRefreshObservable(): Observable<HttpEvent<any>> {
    return new Observable((observer) => {
      this.tokenRefreshed$.subscribe(() => {
        observer.next();
        observer.complete();
      });
    });
  }
}
